// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OTP digit layout — login modal */
.otp-input-wrapper {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.otp-input,
.bv-login-otp-digit {
  width: 46px;
  height: 52px;
  font-size: 1.25rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  text-align: center;
}

@media (min-width: 1400px) {
  .otp-input,
  .bv-login-otp-digit {
    width: 50px;
    height: 56px;
    font-size: 1.35rem;
  }
}

@media (max-width: 1199px) {
  .otp-input,
  .bv-login-otp-digit {
    width: 44px;
    height: 50px;
    font-size: 1.15rem;
  }
}

@media (max-width: 991px) {
  .otp-input,
  .bv-login-otp-digit {
    width: 40px;
    height: 46px;
    font-size: 1.05rem;
  }
}

@media (max-width: 767px) {
  .otp-input-wrapper {
    gap: 8px;
  }

  .otp-input,
  .bv-login-otp-digit {
    width: 36px;
    height: 42px;
    font-size: 1rem;
  }
}

@media (max-width: 575px) {
  .otp-input-wrapper {
    gap: 6px;
  }

  .otp-input,
  .bv-login-otp-digit {
    width: 32px;
    height: 40px;
    font-size: 0.95rem;
  }
}

@media (max-width: 400px) {
  .otp-input-wrapper {
    gap: 4px;
  }

  .otp-input,
  .bv-login-otp-digit {
    width: 28px;
    height: 36px;
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/login.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":["/* OTP digit layout — login modal */\n.otp-input-wrapper {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.otp-input,\n.bv-login-otp-digit {\n  width: 46px;\n  height: 52px;\n  font-size: 1.25rem;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  text-align: center;\n}\n\n@media (min-width: 1400px) {\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 50px;\n    height: 56px;\n    font-size: 1.35rem;\n  }\n}\n\n@media (max-width: 1199px) {\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 44px;\n    height: 50px;\n    font-size: 1.15rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 40px;\n    height: 46px;\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .otp-input-wrapper {\n    gap: 8px;\n  }\n\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 36px;\n    height: 42px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 575px) {\n  .otp-input-wrapper {\n    gap: 6px;\n  }\n\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 32px;\n    height: 40px;\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .otp-input-wrapper {\n    gap: 4px;\n  }\n\n  .otp-input,\n  .bv-login-otp-digit {\n    width: 28px;\n    height: 36px;\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
